export const LOAD_STATE = /** @type {const} */({
  INITAL: 1,
  LOADING: 2,
  LOADED: 3,
  ERROR: 4,
});